import api from "services/api";

export async function fetchCustomerMe(): Promise<{ email: string }> {
  const headers = {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };

  const response = await api.get(`industrial/customer/v1/customers/me`, {
    headers,
  });

  return response.data;
}
